import { components as ReactSelectComponents } from 'react-select';
import { CFAIcon } from 'app/koddi-components/src/_ChakraComponents/Icons';
import { CRow } from 'app/koddi-components/src/_ChakraComponents/Layouts';
import { faChartLine, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Spacing } from 'app/koddi-components/src/_ChakraComponents/ChakraTheme';

type IconControlProps = any & {
    icon: IconDefinition;
};

export const IconControl = ({
    children,
    ...props
}: IconControlProps): JSX.Element => {
    const { icon } = props.selectProps;
    return (
        <ReactSelectComponents.Control {...props}>
            <CRow
                gap={Spacing.XXS}
                noBreak
                alignItems="center"
                width="100%"
                px={Spacing.XS}
                position="relative"
            >
                <CFAIcon icon={icon || faChartLine} />
                {children}
            </CRow>
        </ReactSelectComponents.Control>
    );
};
